import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { EarnCoinData } from "@/app/dummydata/navBarData";

interface EarnCoinsDetailsProps {
  open: any;
  close: any;
}

const EarnCoinsDetails: React.FC<EarnCoinsDetailsProps> = ({ open, close }) => {
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        closeAfterTransition={false}
        sx={{
          "@media (max-width: 600px)": {
            "& .MuiDialog-paper": {
              width: "100%",
              height: "100%",
              maxHeight: "100%",
              maxWidth: "100%",
              margin: 0,
            },
          },
        }}
      >
        <Box
          sx={{
            overflow: "auto",
            background:
              "linear-gradient(180deg, rgba(245, 251, 247, 0.98) 0%, #ffffff 100%)",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <Box
            sx={{
              width: "-webkit-fill-available",
              textAlign: "end",
              padding: "0.5rem 0.5rem 0px 0px",
              background: "linear-gradient(135deg, rgba(223, 246, 232, 0.6) 0%, rgba(255, 255, 255, 0.9) 100%)",
              borderBottom: "1px solid rgba(18, 53, 36, 0.08)",
            }}
          >
            <IconButton onClick={close}>
              <CloseIcon sx={{ color: "#123524" }} />
            </IconButton>
          </Box>
          <Box
            sx={{
              padding: "1rem",
            }}
          >
            {EarnCoinData.map((item, index) => (
              <Box
                key={index}
                sx={{
                  background: "white",
                  borderRadius: "16px",
                  marginBottom: "1rem",
                  border: "1px solid rgba(18, 53, 36, 0.1)",
                  boxShadow: "0 8px 24px rgba(18, 53, 36, 0.06)",
                }}
              >
                <DialogContent>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 700, color: "#123524" }}
                  >
                    {item.heading}
                  </Typography>
                  <br />
                  {item.subHeading.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "start",
                      }}
                    >
                      <CheckIcon
                        sx={{
                          color: "#1f7a4d",
                          fontSize: "20px",
                          marginTop: "2px",
                        }}
                      />
                      &nbsp; &nbsp;
                      <Typography variant="body2" sx={{ marginBottom: "8px" }}>
                        {item}
                      </Typography>
                    </Box>
                  ))}
                </DialogContent>
              </Box>
            ))}
          </Box>
        </Box>
      </Dialog>
    </React.Fragment>
  );
};

export default EarnCoinsDetails;
